import { Link } from "react-router-dom";
import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

import Alraqa from "./Alraqa.jpeg";

const locations = [
  { name: "Point A", latitude: 51.505, longitude: -0.09 },
  { name: "Point B", latitude: 51.515, longitude: -0.1 },
];

const ProviencesSyria = () => {
  return (
    <>
      <section id="map" className="  myMap map features ">
        <h2 className="features-heading" style={{ textAlign: "right" }}>
          {" "}
          سوريا :
        </h2>
        <div className="feature-cards">
          {[
            {
              title: " الرقة ",
              desc: "اضغط لعرض المتاجر في الرقة ",
              img: Alraqa,
              routComp: "alraqa",
            },
          ].map((feature, index) => (
            <Link to={`/${feature.routComp}`}>
              <div
                key={index}
                className={`dark-locations  dark-cards feature-card provience`}
                style={{
                  background: `url(${feature.img}) `,
                  backgroundSize: "cover",
                  color: "white",
                  backgroundPosition: "center",
                }}
              >
                <h4
                  style={{
                    width: "fit-content",
                    background: "rgb(0,0,0,0.5)",
                    placeSelf: "end",
                    borderRadius: "5px",
                  }}
                >
                  <FaMapMarkerAlt className="check-icon" size={20} />
                  {feature.title}
                </h4>
                <p
                  style={{
                    width: "fit-content",
                    background: "rgb(0,0,0,0.5)",
                    placeSelf: "end",
                    borderRadius: "5px",
                    fontSize: "12px",
                  }}
                >
                  {feature.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};

export default ProviencesSyria;
